import { TabContext, TabList, TabPanel } from "@mui/lab";
import { Stack, Tab, Typography } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import { filterStatType } from "../../../../../modules/stats/server/analytics-service";
import { AnalyticsSendsTableExpandedInteractionsByLink } from "./expanded-interactions-by-link";
import { AnalyticsSendsTableExpandedInteractionsByPerson } from "./expanded-interactions-by-person";

import type { GroupedMomentAnalyticsData } from "../../../../../modules/stats/server/analytics-service";
import type { FC, SyntheticEvent } from "react";

export const AnalyticsSendsTableExpandedPageInteractions: FC<{
  stats: GroupedMomentAnalyticsData["stats"];
}> = ({ stats }) => {
  const [tab, setTab] = useState<"person" | "link">("person");
  const handleChange = useCallback((_: SyntheticEvent, value: "person" | "link") => {
    setTab(value);
  }, []);

  const { interactions, visitors } = useMemo(() => {
    const clicks = filterStatType("click", stats);
    const visitorIds = new Set(
      clicks.map(
        ({ data }) =>
          data.recipient_data?.person_id ??
          data.recipient_data?.destination ??
          data.recipient_data?.id ??
          "unknown",
      ),
    );

    return {
      interactions: clicks.reduce((total, { data }) => total + data.count, 0),
      visitors: visitorIds.size,
    };
  }, [stats]);

  return (
    <Stack spacing={2}>
      <Stack direction="row" alignItems="baseline" spacing={2}>
        <Typography variant="h4">{interactions}</Typography>
        <Typography variant="body2" color="text.secondary">
          page link {interactions === 1 ? "click" : "clicks"} from {visitors}{" "}
          {visitors === 1 ? "visitor" : "visitors"}
        </Typography>
      </Stack>
      <TabContext value={tab}>
        <TabList onChange={handleChange}>
          <Tab label="By person" value="person" />
          <Tab label="By link" value="link" />
        </TabList>
        <TabPanel value="person">
          <AnalyticsSendsTableExpandedInteractionsByPerson stats={stats} isLinkedPage />
        </TabPanel>
        <TabPanel value="link">
          <AnalyticsSendsTableExpandedInteractionsByLink stats={stats} isLinkedPage />
        </TabPanel>
      </TabContext>
    </Stack>
  );
};
